import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import { FaLinkedin, FaWhatsapp, FaInstagram } from "react-icons/fa";
import logoLight from "../assets/logo-light.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          <div
            className="col-md-6 col-lg-4"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="100"
          >
            <div className="footer-widget footer-widget--about">
              <a href="/" className="footer-widget__logo">
                <img src={logoLight} width="170" alt="Epaging" />
              </a>
              <p className="footer-widget__text">
                Epaging is an enterprise technology partner — AI agents, video
                intelligence, ERP and the infrastructure to run them.<br></br>
                <br></br>
                <strong>Lets Make IT Work For You!</strong>
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-3"
            data-aos="fade-up"
            data-aos-duration="1300"
            data-aos-delay="200"
          >
            <div className="footer-widget footer-widget--links">
              <h2 className="footer-widget__title">Quick Links</h2>
              <ul className="list-unstyled footer-widget__links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/solutions">Solutions</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
            data-aos-delay="300"
          >
            <div className="footer-widget footer-widget--contact">
              <h2 className="footer-widget__title">Get In Touch</h2>
              <ul className="footer-widget__info">
                <li>
                  <FontAwesomeIcon icon={faPhone} />
                  &nbsp;&nbsp;
                  <a href="tel:02134327000">(021) 343-27-000</a>
                </li>
                <li>
                  <FontAwesomeIcon icon={faEnvelope} />
                  &nbsp;&nbsp;
                  <a href="mailto:info@epaging.net">info@epaging.net</a>
                </li>
                <li>
                  <FontAwesomeIcon icon={faLocationDot} />
                  <a
                    href="https://maps.app.goo.gl/GeA5emFtzyRDtan86"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    &nbsp;&nbsp; Plot # 16/74, Block-3, Bahadur Yar Jang
                    Cooperative Housing Society, Karachi, Pakistan.
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="main-footer__bottom">
          <p className="main-footer__copyright">
            &copy; Copyright {new Date().getFullYear()} by Epaging Pvt Ltd.
          </p>
          <div className="main-footer__social">
            {/* <a href="https://www.facebook.com/ePAGING/">
              <FaFacebookF aria-hidden="true" />
              <span className="sr-only">Facebook</span>
            </a>
            <a href="https://twitter.com/epaging">
              <FaTwitter aria-hidden="true" />
              <span className="sr-only">Twitter</span>
            </a> */}
            <a
              href="https://www.linkedin.com/company/epaging/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin aria-hidden="true" />
              <span className="sr-only">Linkedin</span>
            </a>
            <a
              href="https://wa.me/923435350202"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp aria-hidden="true" />
              <span className="sr-only">Whatsapp</span>
            </a>
            <a
              href="https://www.instagram.com/epagingpvtltd/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram aria-hidden="true" />
              <span className="sr-only">Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
